import { Table } from 'antd'
import type { ColumnsType } from 'antd/es/table'
import { useMemo } from 'react'

type Data = {
  p1: number
  p2: number
  year: number | null
  place: string | null
  type: string
  desc: string
}

type TEvents = Omit<Data, 'p1' | 'p2'> & {
  p1: string
  p2: string
}
export interface IEvents {
  data: Data[]
  id2name: {
    [id: string]: string
  }
  centerId: number
  filterIds: number[]
}

const renderText = (text: string) => (text ? text : '未详')
const EVENT_HASH = {
  kinship: '亲属',
  politics: '政治',
  academia: '学术',
  sociality: '社会',
  religion: '宗教',
  military: '军事',
  others: '其他'
}
const renderType = (text: string) => EVENT_HASH[text] || '其他'

const columns: ColumnsType<TEvents> = [
  {
    title: '人物',
    dataIndex: 'p1'
  },
  {
    title: '人物',
    dataIndex: 'p2'
  },
  {
    title: '时间',
    dataIndex: 'year',
    render: renderText
  },
  {
    title: '地点',
    dataIndex: 'place',
    render: renderText
  },
  {
    title: '事件类型',
    dataIndex: 'type',
    render: renderType,
    filters: Object.keys(EVENT_HASH).map((k) => ({
      text: EVENT_HASH[k],
      value: k
    })),
    onFilter: (value, record) => record.type.includes(value as string)
  },
  {
    title: '事件描述',
    dataIndex: 'desc',
    width: 200,
    ellipsis: true
  }
]

const Events = ({ data, id2name, centerId, filterIds }: IEvents) => {
  const events = useMemo(() => {
    let key1, key2
    if (filterIds.length === 2) {
      const [s, t] = filterIds
      key1 = s + '-' + t
      key2 = t + '-' + s
    }
    return data
      .filter((d) => {
        if (key1 && key2) {
          return key1 === d.p1 + '-' + d.p2 || key2 === d.p1 + '-' + d.p2
        } else {
          return centerId === d.p1 || centerId === d.p2
        }
      })
      .map((d) => ({ ...d, p1: id2name[d.p1], p2: id2name[d.p2] }))
  }, [filterIds, data, centerId, id2name])

  return (
    <div className='events'>
      <div className='events-header'>
        <h3>事件列表</h3>
        <p>数量: {events.length}</p>
      </div>

      <Table size='small' columns={columns} dataSource={events} pagination={{ pageSize: 5 }} />
    </div>
  )
}

export default Events
